<template>
  <v-container fluid fill-height class="pa-0 no-rubber">
    <v-layout column class="no-rubber">
      <v-toolbar flat>
        <div style="flex: 1 1 100%; display: flex; flex-wrap: nowrap; justify-content: space-between; align-items: center;">
          <v-expand-x-transition>
            <v-toolbar-title v-show="!searchVisible">
              Harta
            </v-toolbar-title>
          </v-expand-x-transition>

          <v-expand-x-transition>
            <v-autocomplete
              v-show="searchVisible"
              placeholder="Cautare"
              clearable
              hide-details
              solo
              :loading="loading"
              single-line
              :suffix="String(total)"
              return-object
              :items="filteredItems"
              item-text="id_scara"
              item-value="_id"
              :search-input.sync="search"
              no-filter
              v-model="selectedItem">
              <template v-slot:selection="data">
                <v-avatar size="16">
                  <v-img :src="getIcon(data.item)" height="16" contain/>
                </v-avatar>
                &nbsp;
                {{data.item.id_scara}}
              </template>
              <template v-slot:item="data">
                <v-list-tile-avatar size="22">
                  <v-img :src="getIcon(data.item)" height="22" contain/>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.id_scara"></v-list-tile-title>
                  <v-list-tile-sub-title>{{data.item.user || 'neatribuit'}} - {{data.item.photos.length}} poze</v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </v-autocomplete>
          </v-expand-x-transition>

          <div style="display: flex; align-items: center; justify-content: space-between; flex-wrap: nowrap;">
            <v-btn
              flat
              icon
              :color="onColor"
              @click="searchVisible = !searchVisible">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
            <v-btn
              flat
              icon
              :color="onColor"
              @click="settings = true">
              <v-icon>mdi-cogs</v-icon>
            </v-btn>
            <v-btn
              flat
              icon
              @click="openFiltersDialog"
              :color="filtersStateColor">
              <v-badge color="error" :value="totalFiltersLength">
                <template v-slot:badge>
                  <span class="caption">{{ totalFiltersLength }}</span>
                </template>
                <v-icon>
                  {{ totalFiltersLength ? 'mdi-filter' : 'mdi-filter-off' }}
                </v-icon>
              </v-badge>
            </v-btn>
          </div>
        </div>
      </v-toolbar>

      <GmapMap
        :tilt="0"
        :center="mapCenter"
        :zoom="zoom"
        :map-type-id="mapType"
        :style="{ width: options.width, height: options.height }"
        ref="map"
        :options="{ styles: mapStyles }"
        @center_changed="centerChanged"
        @zoom_changed="zoomChanged"
        @maptypeid_changed="mapTypeChanged">
      </GmapMap>
    </v-layout>

    <!-- <v-btn
      absolute
      fab
      bottom
      left
      :color="onColor"
      style="bottom: 50vh; left: 12px"
      @click="settings = true">
      <v-icon>mdi-cogs</v-icon>
    </v-btn> -->

    <v-dialog v-model="settings" persistent max-width="100vw" :transition="false" no-click-animation hide-overlay scrollable>
      <v-card flat height="75vh">
        <v-card-title class="headline">Setari harta</v-card-title>
        <v-card-text >
          <v-switch v-model="showExplicatii" label="Afiseaza explicatii">
          </v-switch>

          <v-alert type="info" :value="showExplicatii" style="text-align: left">
            Afisare cerc galben in jurul ultimul simbol accesat/cautat/modificat.
          </v-alert>

          <v-radio-group v-model="showHighlight" column label="Evidentiere ultimul simbol accesat" hint="Afiseaza un cerc galben in jurul ultimului simbol accesat" persistent-hint>
            <v-radio label="Nu" value="false"></v-radio>
            <v-radio label="Da" value="true"></v-radio>
          </v-radio-group>

          <v-alert type="info" :value="showExplicatii" style="text-align: left">
            Afisare etichete markere. Cand etichetele sunt vizibile si exista multe markere pe harta performanta are de suferit. A se folosi doar pe desktop.
          </v-alert>

          <v-radio-group v-model="showLabels" column label="Etichete markere" hint="Afisare etichete sub fiecare marker" persistent-hint>
            <v-radio label="Nu" value="false"></v-radio>
            <v-radio label="Da" value="true"></v-radio>
          </v-radio-group>

          <v-alert type="info" :value="showExplicatii" style="text-align: left">
            Ce obiecte se afiseaza pe harta si in ce mod. Pentru un numar mare de markere (mii) este recomandat sa se afiseze obiectele folosind WebGL.
          </v-alert>
          <v-radio-group v-model="objectsOnMap" column label="Obiecte pe harta" hint="Ce se afiseaza pe harta" persistent-hint>
            <v-radio label="Utilizatori" value="users"></v-radio>
            <v-radio label="Markere" value="markers"></v-radio>
            <v-radio label="Utilizatori si Markere" value="users_and_markers"></v-radio>
          </v-radio-group>

          <v-alert type="info" :value="showExplicatii" style="text-align: left">
            Modalitate desenare obiecte pe harta.
          </v-alert>
          <v-radio-group v-model="mapgl" column label="Tehnologie randare obiecte pe harta" hint="Imagini detaliate sau vectori" persistent-hint>
            <v-radio label="Imagini" value="icons"></v-radio>
            <v-radio label="Vectori" value="vectors"></v-radio>
          </v-radio-group>

          <v-alert type="info" :value="showExplicatii" style="text-align: left">
            Dimensiune imagini markere. Imaginea are, implicit, dimensiunile 20x32px.
          </v-alert>
          <v-text-field
            class="mt-3"
            :value="iconScale"
            @input="setTempScale"
            label="Factor scala imagini markere"
            type="number"
            step="0.1"
            append-icon="mdi-send"
            @click:append="applyNewScale">
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="settings = false" color="error">Inchide</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- search dialog -->
    <!-- <v-dialog v-model="searchDialog" persistent max-width="100vw" :transition="false" no-click-animation hide-overlay scrollable>
      <v-card flat max-height="75vh">
        <v-card-title>
          <h1 class="headline">
            Cautare simboluri
          </h1>
        </v-card-title>
        <v-card-text ref="filtersContainer">
          <v-autocomplete
            placeholder="Cautare"
            clearable
            persistent-hint
            hint="Cautare dupa id scara/asoc, adresa scara/asoc, obs"

            solo
            :loading="loading"
            single-line
            :suffix="String(total)"

            return-object
            :items="filteredItems"
            item-text="id_scara"
            item-value="_id"
            :search-input.sync="search"
            no-filter
            v-model="selectedItem">
            <template v-slot:selection="data">
              <v-avatar size="16">
                <v-img :src="getIcon(data.item)" height="16" contain/>
              </v-avatar>
              &nbsp;
              {{data.item.id_scara}}
            </template>
            <template v-slot:item="data">
              <v-list-tile-avatar size="22">
                <v-img :src="getIcon(data.item)" height="22" contain/>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-html="data.item.id_scara"></v-list-tile-title>
                <v-list-tile-sub-title>{{data.item.user || 'neatribuit'}} - {{data.item.photos.length}} poze</v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="searchDialog = false">Inchide</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <!-- filters dialog -->
    <v-dialog v-model="filtersDialog" persistent max-width="500px" :transition="false" no-click-animation hide-overlay scrollable>
      <v-card flat height="75vh">
        <v-card-title>
          <h1 class="headline">
            Filtrare simboluri
          </h1>
        </v-card-title>
        <v-card-text ref="filtersContainer">
          <v-alert type="info" outline :value="true" ref="scrollTargetTop">
            Filtrele aplicate afecteaza atat informatiile din lista de simboluri cat si colectia de elemente de pe harta.
          </v-alert>

          <v-container fluid grid-list-md class="pa-0">
            <v-layout row>
              <v-flex xs12>
                <v-card>
                  <v-card-title>
                    Filtre generale
                  </v-card-title>
                  <v-card-text>
                    <!-- eticheta -->
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-select
                          v-model="filtersDialogLabels"
                          :items="labelsText"
                          label="Eticheta"
                          clearable
                          prepend-icon="mdi-label"
                          chips
                          multiple>
                          <template v-slot:selection="{ item }">
                            <v-chip small outline :text-color="onColor">{{ item }}</v-chip>
                          </template>
                        </v-select>
                      </v-flex>
                    </v-layout>

                    <!-- zona -->
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-select
                          v-model="filtersDialogZones"
                          :items="zonesText"
                          label="Zona"
                          clearable
                          prepend-icon="mdi-vector-polygon"
                          chips
                          multiple>
                          <template v-slot:selection="{ item }">
                            <v-chip small outline :text-color="onColor">{{ item }}</v-chip>
                          </template>
                        </v-select>
                      </v-flex>
                    </v-layout>

                    <!-- interval -->
                    <template v-if="user && user.admin">
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-menu
                            v-model="filtersDialogStartDateMenu"
                            :close-on-content-click="false"
                            full-width
                            max-width="290">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                prepend-icon="mdi-calendar"
                                :value="filtersDialogStartDate | dateFormat"
                                clearable
                                @click:clear="filtersDialogStartDate = null"
                                label="Data inceput"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="filtersDialogStartDate"
                              @change="filtersDialogStartDateMenu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs12>
                          <v-menu
                            v-model="filtersDialogEndDateMenu"
                            :close-on-content-click="false"
                            full-width
                            max-width="290">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                prepend-icon="mdi-calendar"
                                :value="filtersDialogEndDate | dateFormat"
                                clearable
                                @click:clear="filtersDialogEndDate = null"
                                label="Data sfarsit"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="filtersDialogEndDate"
                              @change="filtersDialogEndDateMenu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-layout>
                    </template>

                    <!-- user -->
                    <template v-if="user && user.admin">
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-select
                            v-model="filtersDialogUsers"
                            :items="usersList"
                            :menu-props="{ maxHeight: '400' }"
                            label="Filtru utilizator(i) (ultima persoana care a intervenit pe detaliile entitatii)"
                            multiple
                            clearable
                            chips
                            prepend-icon="mdi-account"
                            :color="onColor">
                            <template v-slot:selection="{ item }">
                              <v-chip small outline :text-color="onColor">{{ item }}</v-chip>
                            </template>
                          </v-select>
                        </v-flex>
                      </v-layout>
                    </template>

                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          v-model.number="filtersDialogPerPage"
                          hide-details
                          type="number"
                          min="1"
                          :color="onColor"
                          flat
                          prepend-icon="mdi-pound"
                          label="Simboluri pe pagina">
                        </v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                      <v-flex xs8>
                        <v-select
                          v-model="filtersDialogSortField"
                          :items="sortList"
                          label="Camp sortare rezultate"
                          chips
                          prepend-icon="mdi-account"
                          :color="onColor">
                          <template v-slot:selection="{ item }">
                            <v-chip small outline :text-color="onColor">{{ item }}</v-chip>
                          </template>
                        </v-select>
                      </v-flex>
                      <v-flex xs4 style="display: flex; align-items: center">
                        <v-btn-toggle mandatory v-model="filtersDialogSortOrder" class="transparent">
                          <v-btn flat :value="1">
                            <v-icon :color="filtersDialogSortOrder === 1 ? onColor : offColor">mdi-arrow-up</v-icon>
                          </v-btn>
                          <v-btn flat :value="-1">
                            <v-icon :color="filtersDialogSortOrder === -1 ? onColor : offColor">mdi-arrow-down</v-icon>
                          </v-btn>
                        </v-btn-toggle>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>

            <!-- done, edited, photos, repozare, myEntities, pdfs, excels -->

            <template v-for="(filterSet, index) in filtersDialogItems">
              <v-layout row :key="index">
                <v-flex xs12>
                  <v-card>
                    <v-card-title>
                      <span>Set filtre {{  index + 1 }}</span>
                      <v-spacer></v-spacer>
                      <v-btn icon small @click="removeFilterSet(index)">
                        <v-icon color="error">mdi-close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text>
                      <v-list two-line>
                        <template v-for="(value, filter) in filterSet">
                          <v-list-tile :key="filter" @click="toggleFilter(index, filter)">
                            <v-list-tile-avatar>
                              <v-icon>
                                {{filterIcons[filter][null]}}
                              </v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{ filterLabels[filter] }}
                              </v-list-tile-title>
                              <v-list-tile-sub-title>
                                <v-chip small outline label :color="light ? filterColors.light[value] : filterColors.dark[value]">
                                  {{filterText[filter][value]}}
                                </v-chip>
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-icon left :color="light ? filterColors.light[value] : filterColors.dark[value]" v-if="value !== null">
                                {{filterIcons[filter][value]}}
                              </v-icon>
                            </v-list-tile-action>
                          </v-list-tile>
                        </template>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </template>
            <v-layout>
              <v-flex xs12  class="d-flex">
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="addFilterSet">
                  <v-icon left>mdi-plus</v-icon>
                  Adauga set
                </v-btn>
                <v-spacer></v-spacer>
              </v-flex>
            </v-layout>
          </v-container>
          <p ref="scrollTargetBottom"></p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeFiltersDialog">Renunta</v-btn>
          <v-btn :color="onColor" flat @click="applyFilters">Aplica</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import darkStyle from '@/mapstyles/dark.json'
import { gmapApi } from 'vue2-google-maps'
import debounce from 'lodash.debounce'
import SERVER_URL from '@/config'

import { GoogleMapsOverlay as DeckOverlay } from '@deck.gl/google-maps'
import { GeoJsonLayer } from '@deck.gl/layers'

export default {
  name: 'entity-map',
  props: {
    entity: {
      type: String,
      required: false
    }
  },
  filters: {
    dateFormat (date) {
      return date ? new Date(date).toLocaleString('ro-RO', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' }) : 'nimic selectat'
    }
  },
  computed: {
    searchVisible: {
      get () {
        return this.$store.getters.searchVisible
      },
      set (value) {
        this.$store.commit('setSearchVisible', value)
      }
    },
    mapStyles () {
      return this.light ? [] : darkStyle
    },
    google: gmapApi,
    currentPosition () {
      return this.$store.getters.currentPosition
    },
    loading () {
      return this.$store.getters.loading
    },
    mapCenter () {
      return this.$store.getters.mapCenter
    },
    zoom () {
      return this.$store.getters.zoom
    },
    mapType () {
      return this.$store.getters.mapType
    },
    total () {
      return this.filteredItems.length
    },
    activeEntity () {
      return this.$route.params.entity
    },
    user () {
      return this.$store.getters.user
    },
    items () {
      return this.$store.getters['entities/allItems']
    },
    grouping: {
      get () {
        return this.$store.getters['entities/grouping']
      },
      set () {
        this.$store.commit('entities/toggleGrouping')
      }
    },
    showHighlight: {
      get () {
        return this.$store.getters['entities/showHighlight']
      },
      set () {
        this.$store.commit('entities/toggleHighlight')
      }
    },
    showLabels: {
      get () {
        return this.$store.getters['entities/showLabels']
      },
      set () {
        this.$store.commit('entities/toggleLabels')
      }
    },
    iconScale: {
      get () {
        return Number(this.$store.getters['entities/iconScale']) || 1
      },
      set (value) {
        this.$store.commit('entities/setIconScale', value)
      }
    },
    usersLocations () {
      return this.$store.getters.usersLocations
    },
    objectsOnMap: {
      get () {
        return this.$store.getters['entities/objectsOnMap']
      },
      set (value) {
        this.$store.commit('entities/setObjectsOnMap', value)
      }
    },
    mapgl: {
      get () {
        return this.$store.getters['entities/mapgl']
      },
      set (value) {
        this.$store.commit('entities/setmapgl', value)
      }
    },
    highlightEntityGeojson () {
      const json = this.items.filter(item => item._id === this.highlightEntity).map(item => {
        return {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [item.centru_geometric.lng, item.centru_geometric.lat]
          },
          properties: {
            done: item.done,
            user: item.user,
            zona: item.zona,
            repozare: item.repozare,
            repozare_check: item.repozare_check,
            repozare_done: item.repozare_done,
            _id: item._id,
            id_scara: item.id_scara,
            icon: this.getIcon(item)
          }
        }
      })

      return json
    },
    geoJsonItems () {
      const json = this.items.map(item => {
        return {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [item.centru_geometric.lng, item.centru_geometric.lat]
          },
          properties: {
            done: item.done,
            user: item.user,
            zona: item.zona,
            repozare: item.repozare,
            repozare_check: item.repozare_check,
            repozare_done: item.repozare_done,
            _id: item._id,
            id_scara: item.id_scara,
            icon: this.getIcon(item)
          }
        }
      })

      return json
    },
    geoJsonUsers () {
      const json = this.usersLocations.map(item => {
        return {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [item.position.lng, item.position.lat]
          },
          properties: {
            username: item.username,
            icon: `${this.url}/svg/${item.username}-logo.png`
          }
        }
      })

      return json
    },
    usersColors () {
      return this.$store.getters.users.reduce((acc, user) => {
        acc[user.username] = [
          parseInt(user.color.substr(-6, 2), 16),
          parseInt(user.color.substr(-4, 2), 16),
          parseInt(user.color.substr(-2), 16),
          255
        ]
        return acc
      }, {})
    },
    light () {
      return this.$store.getters.light
    },
    onColor () {
      return this.$store.getters.onColor
    },
    offColor () {
      return this.$store.getters.offColor
    },
    labelColor () {
      return this.light ? 'black' : 'white'
    },
    markerSize () {
      return {
        width: this.mw * this.iconScale,
        height: this.mh * this.iconScale
      }
    },
    userSize () {
      return {
        width: this.uw * this.iconScale,
        height: this.uh * this.iconScale
      }
    },
    visibility () {
      // build and returns an object with layer visibility for all map layers
      return {
        markerIcons: this.mapgl === 'icons',
        markerVectors: this.objectsOnMap.includes('markers') && this.mapgl === 'vectors',
        markerTexts: this.objectsOnMap.includes('markers') && (this.showLabels === 'true' || this.showLabels === true),
        userIcons: this.objectsOnMap.includes('users'),
        userTexts: this.objectsOnMap.includes('users') && (this.showLabels === 'true' || this.showLabels === true),
        highlightEntity: this.highlightEntity && (this.showHighlight === 'true' || this.showHighlight === true)
      }
    },
    highlightEntity () {
      return this.$store.getters['entities/highlightEntity']
    },
    labelsText () {
      const etichete = this.$store.getters['entities/labels'].map(label => label.label)
      if (!etichete.length) etichete.push('Fara eticheta')
      return etichete
    },
    zonesText () {
      const zone = this.$store.getters['entities/zones'].map(zona => zona.zona)
      if (!zone.length) zone.push('Fara zona')
      return zone
    },
    usersList () {
      return this.$store.getters['entities/dbusernames']
    },
    sort () {
      return this.$store.getters['entities/sort']
    },
    sortList () {
      return this.$store.getters.sortList
    },
    filtersStateColor () {
      if (this.light) {
        return this.totalFiltersLength ? 'primary' : 'blue-grey'
      } else {
        return this.totalFiltersLength ? 'primary lighten-2' : 'grey lighten-2'
      }
    },
    newFilters () {
      return this.$store.getters['entities/newFilters']
    },
    selectedLabel () {
      return this.$store.getters['entities/selectedLabel']
    },
    selectedZona () {
      return this.$store.getters['entities/selectedZona']
    },
    dataInceput () {
      return this.$store.getters['entities/dataInceput']
    },
    dataSfarsit () {
      return this.$store.getters['entities/dataSfarsit']
    },
    selectedUsernames () {
      return this.$store.getters['entities/selectedUsernames']
    },
    totalFiltersLength () {
      return this.newFilters.length + (this.selectedLabel.length !== 0) + (this.selectedZona.length !== 0) + (this.dataInceput !== null) + (this.dataSfarsit !== null) + (this.selectedUsernames.length !== 0)
    },
    perPage () {
      return this.$store.getters['entities/perPage']
    }
  },
  watch: {
    highlightEntity (v) {
      if (v) {
        this.buildLayers()
      }
    },
    selectedItem (v) {
      if (v) {
        this.$store.commit('entities/setHighlightEntity', v._id)
        this.$refs.map.$mapPromise.then((map) => {
          map.panTo({ lat: Number(v.centru_geometric.lat), lng: Number(v.centru_geometric.lng) })
          map.setZoom(40)
        })
      }
    },
    search: {
      immediate: false,
      handler: debounce(function (v) {
        this.queryItems(v)
      }, 1000)
    },
    items: {
      immediate: true,
      handler (v) {
        this.filteredItems = v
      }
    },

    // map data
    geoJsonItems: {
      deep: true,
      handler () {
        this.buildLayers()
      }
    },
    geoJsonUsers: {
      deep: true,
      handler () {
        this.buildLayers()
      }
    },

    // map options
    showLabels () {
      this.buildLayers()
    },
    showHighlight () {
      this.buildLayers()
    },
    objectsOnMap () {
      this.buildLayers()
    },
    mapgl () {
      this.buildLayers()
    },
    iconScale () {
      this.buildLayers()
    },

    // label color
    labelColor () {
      this.buildLayers()
    }
  },
  data: () => ({
    showExplicatii: false,
    tempScale: 1,
    settings: false,
    url: SERVER_URL,
    search: null,
    options: Object.freeze({
      width: '100%',
      height: '100%'
    }),
    // items: [],
    filteredItems: [],

    selectedItem: null,
    alphaForGl: 175,

    mw: 20,
    mh: 32,
    uw: 20,
    uh: 20,

    layers: {
      markerIcons: null,
      markerVectors: null,
      markerTexts: null,
      userIcons: null,
      userTexts: null,
      highlightEntity: null
    },

    filtersDialog: false,
    filtersDialogItems: [],
    filtersDialogLabels: [],
    filtersDialogZones: [],

    filtersDialogStartDateMenu: false,
    filtersDialogStartDate: null,
    filtersDialogEndDateMenu: false,
    filtersDialogEndDate: null,

    filtersDialogUsers: [],
    filtersDialogPerPage: 10,

    filtersDialogSortField: null,
    filtersDialogSortOrder: 1,

    searchDialog: false
  }),
  methods: {
    setFiltersDialogItems () {
      this.filtersDialogItems = JSON.parse(JSON.stringify(this.newFilters))
      this.filtersDialogLabels = JSON.parse(JSON.stringify(this.selectedLabel))
      this.filtersDialogZones = JSON.parse(JSON.stringify(this.selectedZona))

      this.filtersDialogStartDate = JSON.parse(JSON.stringify(this.dataInceput))
      this.filtersDialogEndDate = JSON.parse(JSON.stringify(this.dataSfarsit))

      this.filtersDialogUsers = JSON.parse(JSON.stringify(this.selectedUsernames))

      this.filtersDialogPerPage = JSON.parse(JSON.stringify(this.perPage))

      this.filtersDialogSortField = JSON.parse(JSON.stringify(this.sort.field))
      this.filtersDialogSortOrder = JSON.parse(JSON.stringify(this.sort.order))
    },
    openFiltersDialog () {
      this.setFiltersDialogItems()
      this.filtersDialog = true
    },
    removeFilterSet (index) {
      this.filtersDialogItems.splice(index, 1)
    },
    addFilterSet () {
      this.filtersDialogItems.push(JSON.parse(JSON.stringify(this.filtersTemplate)))

      this.$nextTick(() => {
        this.$vuetify.goTo(this.$refs.scrollTargetBottom, {
          container: this.$refs.filtersContainer,
          duration: 500,
          offset: 0,
          easing: 'easeInOutCubic'
        })
      })
    },
    toggleFilter (index, filter) {
      // values:
      // null = no filter ( or 'all' for myEntities)
      // 1 = filter set to true (or 'mine' for myEntities)
      // -1 = filter set to false (or 'not mine' for myEntities)

      // possible values:
      // done: true|false, user: null|string, repozare: null|Da|Nu, photos|pdfs|excels: []|[strings]

      if (this.filtersDialogItems[index][filter] === null) {
        this.filtersDialogItems[index][filter] = 1
      } else if (this.filtersDialogItems[index][filter] === 1) {
        this.filtersDialogItems[index][filter] = -1
      } else if (this.filtersDialogItems[index][filter] === -1 && ['myEntities', 'repozare', 'repozare_done', 'repozare_check'].includes(filter)) {
        this.filtersDialogItems[index][filter] = 0
      } else { // not done
        this.filtersDialogItems[index][filter] = null
      }
    },
    applyFilters () {
      this.$store.commit('entities/setSelectedLabel', this.filtersDialogLabels)
      this.$store.commit('entities/setSelectedZona', this.filtersDialogZones)

      this.$store.commit('entities/setDataInceput', this.filtersDialogStartDate)
      this.$store.commit('entities/setDataSfarsit', this.filtersDialogEndDate)

      this.$store.commit('entities/setSelectedUsernames', this.filtersDialogUsers)

      if (this.filtersDialogPerPage <= 0) this.filtersDialogPerPage = 10
      this.$store.commit('entities/setPerPage', this.filtersDialogPerPage)

      this.$store.commit('entities/setSort', { field: this.filtersDialogSortField, order: this.filtersDialogSortOrder })

      this.$store.dispatch('entities/applyFilters', this.filtersDialogItems)

      this.closeFiltersDialog()
    },
    closeFiltersDialog () {
      this.setFiltersDialogItems()
      this.filtersDialog = false
    },
    setTempScale ($event) {
      this.tempScale = $event
    },
    applyNewScale ($event) {
      this.iconScale = this.tempScale
    },
    queryItems (search) {
      this.filteredItems = search ? this.items.filter(item => this.filter(item, search, item.id_scara) || this.filter(item, search, item.adresa) || this.filter(item, search, item.observatii_scara)) : this.items
    },
    filter (item, search, value) {
      return value ? value.toLowerCase().includes(search.toLowerCase()) : false
    },
    centerChanged: debounce(function ($event) {
      const mapCenter = { lat: $event.lat(), lng: $event.lng() }
      this.$store.commit('setMapCenter', mapCenter)
    }, 1000),
    zoomChanged: debounce(function ($event) {
      this.$store.commit('setZoom', $event)
    }, 1000),
    mapTypeChanged ($event) {
      // if ($event === 'roadmap' || $event === 'terrain') this.labelColor = 'black'
      // else this.labelColor = 'white'
      this.$store.commit('setMapType', $event)
    },
    getIcon (marker) {
      if (marker.user) {
        if (marker.repozare === 'Da') {
          if (marker.repozare_check === 'Da') return `${this.url}/svg/${marker.user}-repozare_check.png`
          if (marker.repozare_check === 'Nu') return `${this.url}/svg/${marker.user}-repozare.png`
          if (marker.repozare_done === 'Da') return `${this.url}/svg/${marker.user}-repozare_done.png`
          return `${this.url}/svg/${marker.user}-repozare.png`
        }
        return marker.done ? `${this.url}/svg/${marker.user}-done.png` : `${this.url}/svg/${marker.user}-edited.png`
      }

      return `${this.url}/svg/default.png`
    },
    getCircleFillColor (marker) {
      if (marker.user) {
        if (marker.repozare === 'Da') {
          if (marker.repozare_check === 'Da') return [0, 182, 147, this.alphaForGl] // repozare check #00b693
          if (marker.repozare_check === 'Nu') return [255, 82, 82, this.alphaForGl] // repozare #ff5252
          if (marker.repozare_done === 'Da') return [120, 130, 139, this.alphaForGl] // repozare done #78828b
          return [255, 82, 82, this.alphaForGl] // repozare #ff5252
        }
        return marker.done ? [0, 255, 0, this.alphaForGl] : [0, 0, 255, this.alphaForGl] // done #00ff00 and edited #0000ff
      }

      return [255, 255, 255, this.alphaForGl]
    },
    getCircleLineColor (marker) {
      return this.usersColors[marker.user] || [0, 0, 0, this.alphaForGl]
    },
    navigate (marker) {
      this.$store.commit('entities/setHighlightEntity', marker._id)
      if (this.$route.name !== 'dashboard') {
        this.$router.push({ name: 'details', params: { entity: marker._id } })
      } else {
        this.$emit('marker-clicked', this.items.find(item => item._id === marker._id))
      }
    },

    buildLayers: debounce(function () {
      const labelColor = this.labelColor
      let textColor

      switch (labelColor) {
        case 'black':
          textColor = [0, 0, 0, 255]
          break
        case 'white':
          textColor = [255, 255, 255, 255]
          break
      }

      this.layers = {
        markerIcons: new GeoJsonLayer({
          visible: this.visibility.markerIcons,
          id: 'markerImages',
          data: this.geoJsonItems,
          pointType: 'icon',

          // Icon
          getIcon: f => {
            return {
              url: f.properties.icon,
              height: 160,
              width: 100,
              anchorY: 160,
              anchorX: 50
            }
          },
          getIconSize: this.markerSize.height,

          // Interactive props

          pickable: true,
          autoHighlight: true,

          onClick: e => {
            this.navigate({ _id: e.object.properties._id })
          }
        }),
        markerVectors: new GeoJsonLayer({
          visible: this.visibility.markerVectors,
          id: 'markerVectors',
          data: this.geoJsonItems,
          pointType: 'circle',

          // Styles

          pointRadiusUnits: 'meters',
          getPointRadius: 2,
          pointRadiusScale: 1,
          pointRadiusMinPixels: 8 * this.iconScale,
          pointRadiusMaxPixels: 12 * this.iconScale,
          pointAntialiasing: true,
          pointBillboard: false,

          filled: true,
          getFillColor: f => this.getCircleFillColor(f.properties),
          getLineColor: f => this.getCircleLineColor(f.properties),
          getLineWidth: 20,
          lineWidthMinPixels: 1,
          lineWidthMaxPixels: 2,

          // Interactive props

          pickable: true,
          autoHighlight: true,

          onClick: e => {
            this.navigate({ _id: e.object.properties._id })
          }
        }),
        markerTexts: new GeoJsonLayer({
          visible: this.visibility.markerTexts,
          id: 'markerTexts',
          data: this.geoJsonItems,
          pointType: 'text',

          // Text
          getText: f => f.properties.id_scara,
          getTextColor: textColor,
          getTextSize: 12,
          textSizeScale: this.iconScale,
          getTextAlignmentBaseline: 'top',
          textFontWeight: 'bold',
          getTextPixelOffset: [0, 10 * this.iconScale],
          textSizeMinPixels: 12,
          textSizeMaxPixels: 28,

          // Interactive props

          pickable: true,
          autoHighlight: true,

          onClick: e => {
            this.navigate({ _id: e.object.properties._id })
          }
        }),
        userIcons: new GeoJsonLayer({
          visible: this.visibility.userIcons,
          id: 'userIcons',
          data: this.geoJsonUsers,
          pointType: 'icon',

          // Icon
          getIcon: f => {
            return {
              url: f.properties.icon,
              height: 100,
              width: 100,
              anchorY: 100,
              anchorX: 50
            }
          },
          getIconSize: this.userSize.height
        }),
        userTexts: new GeoJsonLayer({
          visible: this.visibility.userTexts,
          id: 'userTexts',
          data: this.geoJsonUsers,
          pointType: 'text',

          // Text
          getText: f => f.properties.username,
          getTextColor: textColor,
          getTextSize: 12,
          textSizeScale: this.iconScale,
          getTextAlignmentBaseline: 'top',
          textFontWeight: 'bold',
          getTextPixelOffset: [0, 2 * this.iconScale],
          textSizeMinPixels: 12,
          textSizeMaxPixels: 28
        }),
        highlightEntity: new GeoJsonLayer({
          visible: this.visibility.highlightEntity,
          id: 'highlightEntity',
          data: this.highlightEntityGeojson,
          pointType: 'circle',

          // Styles

          pointRadiusUnits: 'meters',
          getPointRadius: 20,
          pointRadiusScale: 1,
          pointRadiusMinPixels: 20 * this.iconScale,
          pointRadiusMaxPixels: 40 * this.iconScale,
          pointAntialiasing: true,
          pointBillboard: false,

          filled: true,
          getFillColor: [0, 0, 0, 0],
          // golden color
          getLineColor: [255, 215, 0, 255],
          getLineWidth: 8,
          lineWidthMinPixels: 8,
          lineWidthMaxPixels: 12
        })
      }

      this.updateMap()
    }, 500),

    updateMap () {
      if (window.overlay) {
        window.overlay.setProps({
          layers: [
            this.layers.markerIcons,
            this.layers.markerVectors,
            this.layers.markerTexts,
            this.layers.userIcons,
            this.layers.userTexts,
            this.layers.highlightEntity
          ]
        })
      }
    },

    drawOnMap () {
      this.$refs.map.$mapPromise.then(() => {
        window.overlay = new DeckOverlay({
          layers: [
            this.layers.markerIcons,
            this.layers.markerVectors,
            this.layers.markerTexts,
            this.layers.userIcons,
            this.layers.userTexts,
            this.layers.highlightEntity
          ]
        })

        window.overlay.setMap(this.$refs.map.$mapObject)
      })
    },
    clearWebglMap () {
      if (window.overlay) {
        window.overlay.finalize()
        window.overlay = null
      }
    }
  },
  beforeMount () {
    this.$store.dispatch('entities/fetchUsernames')

    this.filtersTemplate = Object.freeze({
      done: null,
      edited: null,
      photos: null,
      repozare: null,
      repozare_done: null,
      repozare_check: null,
      myEntities: null,
      pdfs: null,
      excels: null
    })

    this.filterLabels = Object.freeze({
      done: 'Finalizare',
      edited: 'Editare',
      photos: 'Poze',
      repozare: 'Repozare',
      repozare_done: 'Repozare incheiata',
      repozare_check: 'Repozare corecta',
      myEntities: 'Utilizator simbol',
      pdfs: 'Pdf-uri',
      excels: 'Excel-uri'
    })

    this.filterIcons = Object.freeze({
      done: {
        1: 'mdi-check',
        [-1]: 'mdi-close',
        [null]: 'mdi-check-circle'
      },
      edited: {
        1: 'mdi-pencil',
        [-1]: 'mdi-pencil-off',
        [null]: 'mdi-pencil'
      },
      photos: {
        1: 'mdi-image-multiple',
        [-1]: 'mdi-image-off',
        [null]: 'mdi-camera'
      },
      repozare: {
        1: 'mdi-check',
        [-1]: 'mdi-close',
        0: 'mdi-minus-thick',
        [null]: 'mdi-alpha-r-circle'
      },
      repozare_done: {
        1: 'mdi-check',
        [-1]: 'mdi-close',
        0: 'mdi-minus-thick',
        [null]: 'mdi-alpha-r-circle'
      },
      repozare_check: {
        1: 'mdi-check',
        [-1]: 'mdi-close',
        0: 'mdi-minus-thick',
        [null]: 'mdi-alpha-r-circle'
      },
      myEntities: {
        1: 'mdi-account-star',
        [-1]: 'mdi-account-remove',
        0: 'mdi-account-multiple',
        [null]: 'mdi-account'
      },
      pdfs: {
        1: 'mdi-file-multiple',
        [-1]: 'mdi-close',
        [null]: 'mdi-file-pdf-box'
      },
      excels: {
        1: 'mdi-file-multiple',
        [-1]: 'mdi-close',
        [null]: 'mdi-file-excel'
      }
    })

    // possible values:
    // done: true|false, user: null|string, repozare: null|Da|Nu, photos|pdfs|excels: []|[strings]
    this.filterText = Object.freeze({
      done: {
        1: 'Finalizate',
        [-1]: 'Nefinalizate',
        [null]: 'Filtru neaplicat'
      },
      edited: {
        1: 'Editate',
        [-1]: 'Needitate',
        [null]: 'Filtru neaplicat'
      },
      photos: {
        1: 'Cu Poze',
        [-1]: 'Fara Poze',
        [null]: 'Filtru neaplicat'
      },
      repozare: {
        1: 'Cu Repozare',
        [-1]: 'Fara Repozare',
        0: 'Repozare nesetata',
        [null]: 'Filtru neaplicat'
      },
      repozare_done: {
        1: 'Repozare incheiata',
        [-1]: 'Repozare neincheiata',
        0: 'Nerepozat',
        [null]: 'Filtru neaplicat'
      },
      repozare_check: {
        1: 'Repozare corecta',
        [-1]: 'Repozare incorecta',
        0: 'Neverificat',
        [null]: 'Filtru neaplicat'
      },
      myEntities: {
        1: 'Simbolurile mele',
        [-1]: 'Simboluri neatribuite',
        0: 'Simbolurile altora',
        [null]: 'Filtru neaplicat'
      },
      pdfs: {
        1: 'Cu Pdf-uri',
        [-1]: 'Fara Pdf-uri',
        [null]: 'Filtru neaplicat'
      },
      excels: {
        1: 'Cu Excel-uri',
        [-1]: 'Fara Excel-uri',
        [null]: 'Filtru neaplicat'
      }
    })

    this.filterColors = Object.freeze({
      light: {
        1: 'success',
        [-1]: 'error',
        0: 'primary',
        [null]: 'blue-grey'
      },
      dark: {
        1: 'success',
        [-1]: 'error',
        0: 'primary lighten-2',
        [null]: 'grey lighten-2'
      }
    })
  },
  mounted () {
    this.$store.dispatch('fetchAllUserLocations')
    this.$store.dispatch('fetchUsers')

    this.$refs.map.$mapPromise.then(() => {
      this.drawOnMap()
    })
  },
  beforeDestroy () {
    this.clearWebglMap()
  }
}
</script>

<style>

</style>
